// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_MENU_PRODUCTS = "Inzer\u00e1ty";
export const BZ2_MENU_REVIEWS = "Hodnocen\u00ed";
